export default "__VITE_ASSET__ec157042__"